import { extend, localize } from "vee-validate";
import { required, email, min_value, max_value } from "vee-validate/dist/rules";
import pl from "vee-validate/dist/locale/pl.json";

import dayjs from "dayjs";

localize({ pl });
localize("pl");

extend("required", {
  ...required,
  message: "Pole jest wymagane"
});

extend("email", {
  ...email,
  message: "Wartość powinna być poprawnym adresem e-mail"
});

extend("decimal", {
  validate(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  },

  message:
    "Wartość powinna być liczbą rzeczywistą z kropką jako separatorem dziesiętnym"
});

extend("min_value", {
  ...min_value,
  message: "Wartość powinna być nie mniejsza niż {min}"
});

extend("max_value", {
  ...max_value,
  message: "Wartość powinna być nie większa niż {max}"
});

extend("is_after", {
  params: ["type", "target"],

  validate(value, { type, target }) {
    if (type === "time") {
      return dayjs(`1970-01-01 ${value}`).isAfter(
        dayjs(`1970-01-01 ${target}`)
      );
    }
  },

  message: "Podany czas powinien być późniejszy niż {target}"
});

extend("is_json", {
  params: ["shape"],

  validate(value, { shape }) {
    try {
      const object = JSON.parse(value);

      if (shape) {
        for (var [field, { type, required }] of Object.entries(shape)) {
          if (required && !object[field]) {
            return (
              `Obiekt powinien zawierać pole ${field}` +
              (type ? " typu " + type : "")
            );
          }

          if (
            type &&
            object[field] &&
            object[field].constructor.name !== type
          ) {
            return `Pole ${field} powinno być typu ${type}`;
          }
        }
      }

      return true;
    } catch (e) {
      return "Wartość powinna być prawidłowym kodem JSON";
    }
  }
});

const uri = new RegExp(
  "^(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$",
  "i"
);
extend("is_uri", {
  validate(value) {
    return !!uri.test(value);
  },

  message: "Wartość powinna być prawidłowym identyfikatorem URI"
});
